import { observer } from "mobx-react"
import React from "react"
import StepsJson from "../../Configs/JSON/Steps.json"
// import AppStore from "../../Configs/Store/index"
import AppStore from "../../Configs/Store"
import DOMPurify from "dompurify"

import DynamicCard from "../Common/DynamicCard"
// import RoundCard from "./RoundCard"
import "./Steps.less"

const Steps = observer(() => {
    let cardContents = null
    const device = AppStore.device

    cardContents = StepsJson["cardContents"]

    return (
        <>
            <div className={"StepsSectionWrapper"}>
                <h2 className={"SecTitleDark"}>{StepsJson["TitleText"]}</h2>
                <div className="cardContainer">
                    {cardContents.map((x, i) => (
                        <React.Fragment key={"Steps_" + i}>
                            {x.visible ? (
                                <div className="cardContainer_Parent">
                                    <DynamicCard key={i + 1} data={x} dot={true} arrow={false} title={true} content={true} icon={false}
                                        RootStyle={{
                                            backgroundImage: `url(${x.iconId})`

                                        }
                                        }
                                        wrapperStyle={"cardWrapper"} titleBodyWrapperStyle={"titleBodyWrapper"} contentStyle={"contentText"} />

                                </div>
                            ) : (
                                <></>
                            )}
                        </React.Fragment>
                    ))}
                    {/* <RoundCard text={StepsJson["FinalText"]} textStyle={"RcText"} outerBorderStyle={"RcOuterBorder"} /> */}
                </div>
                {/* {device === 0 ? (
                    <div className={"StepscardContainerMobContentOnly"}>
                        {cardContents.map((x, i) => (
                            <DynamicCard key={i + 1} data={x} dot={false} arrow={false} title={false} content={true} icon={false} wrapperStyle={"cardWrapper"} titleBodyWrapperStyle={"titleBodyWrapper"} titleStyle={"TitleText"} contentStyle={"contentText"} />
                        ))}
                    </div>
                ) : (
                    ""
                )} */}
                <div className="StepsFooter">
                    <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(StepsJson["FooterText"]) }} ></div>
                </div></div>
        </>
    )
})

export default Steps
